var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.authorNames),function(authorRow,index){return _c('span',{key:index},[(authorRow.author_info && authorRow.author_info.author_name)?_c('span',[_vm._v(_vm._s(authorRow.author_info.author_name))]):_vm._e(),(index + 1 < _vm.authorNames.length)?_c('span',[_vm._v(", ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }